export enum SystemConfigTab {
    EmailServer = "Email Server",
    FailedLoginAttemptsPolicy = "Failed Login Attempts Policy",
    Password = "Password",
    Login = "Login",
    Session = "Session",
    Registration = "Registration",
    AWSS3 = "AWS S3",
    Maintenance = "Maintenance",
    Performance = "Performance",
    Customisation = "Customisation",
    AllowedIP = "Allowed IP",
    Feedback = "Feedback",
    ParametersStore = "Parameters Store",
    Pwa = "PWA",
    TwoFactorAuthentication = "2-Factor Authentication",
    RavenApiBase = "Raven API",
    Patient = "Patient",
    Snomed = "SNOMED",
    Formio = "Formio",
    IM1ApiSettings = "NHS Data",
    Logging = "Logging",
    Documents = "Documents",
    AlternateSiteInformationSettings = "Alternate Site Information Settings"
}
